import Swiper from 'swiper';
import { Autoplay, FreeMode, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
// import 'swiper/css/pagination';

const config = {
    modules: [Pagination, FreeMode],
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    freeMode: {
        enabled: true,
        sticky: true
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    breakpoints: {
        576: {
            slidesPerView: 1,
            spaceBetween: 10
        },
        767: {
            slidesPerView: 3,
            spaceBetween: 20
        }
    }

};

document.addEventListener('DOMContentLoaded', () => {
    const slider = document.querySelectorAll('.swiper');

    if( !slider ) return false;

    slider.forEach(slide => {

        const slides_all = slide.getAttribute('data-slides-all');
        const gap_all = slide.getAttribute('data-gap-all');

        if( slides_all ) {
            config.slidesPerView = slides_all;
            config.breakpoints[576].slidesPerView = slides_all;
            config.breakpoints[767].slidesPerView = slides_all;
        }

        if( gap_all ) {
            config.spaceBetween = gap_all;
            config.breakpoints[576].spaceBetween = gap_all;
            config.breakpoints[767].spaceBetween = gap_all;
        }

        new Swiper(slide, config);
    });
});
